import { ColorValue, StyleProp, View, ViewStyle } from "react-native";
import { Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

interface Props {
  name: string;

  // we expliciitly pass bg and text color as props are split between view and text
  backgroundColor?: ColorValue;
  textColor?: ColorValue;

  style?: StyleProp<ViewStyle>;
}

export default function Label(props: Props) {
  const tailwind = useTailwind();
  const { colors } = useTheme();

  const {
    name,
    backgroundColor = colors.tertiaryContainer,
    textColor = colors.onTertiaryContainer,
    style,
  } = props;

  const alignStyle = tailwind("px-1.5 py-0.5 justify-center rounded-md");

  return (
    <View style={[alignStyle, { backgroundColor }, style]}>
      <Text variant="labelMedium" style={{ color: textColor }}>
        {name}
      </Text>
    </View>
  );
}
